import React from 'react';
import { sidebarBem } from '@om-fe/core/components/constants';

export const RightSideBarSkeleton = () => {
    return (
        <aside
            className={sidebarBem({
                modifiers: {
                    Right: true,
                },
            })}
        ></aside>
    );
};

export default RightSideBarSkeleton;
